import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { updateUserDetailsAction } from '../../redux/actions/settings';
import WhatsNewModal from './components/WhatsNewModal';
import SlideModal from './components/SlideModal';
import Props from './typing';

const Tour: FC<Props> = (props): JSX.Element => {
  const [currentStep, setCurrentStep] = useState<number>(-1);
  const [showTourModal, setShowTourModal] = useState<boolean>(false);

  const { showTourByBtnClick, setShowTourByBtnClick, isPACBTour } = props;

  useEffect(() => {
    showTourByBtnClick ? setCurrentStep(isPACBTour ? 0 : 0) : '';
  }, [showTourByBtnClick]);

  const closeModal = () => {
    setShowTourByBtnClick(false);
    setShowTourModal(false);
    setCurrentStep(0);
    if (!isPACBTour && !showTourByBtnClick) {
      props?.updateUserDetailsAction({
        showGuidedTour: false,
        isShowGuidedTourUpdated: true,
      });
    }
  };

  useEffect(() => {
    if (isPACBTour) {
      setShowTourModal(showTourByBtnClick);
    } else {
      setShowTourModal(showTourByBtnClick || props?.showGuidedTour);
    }
  }, [showTourByBtnClick, props?.showGuidedTour]);

  return (
    <>
      {showTourModal ? (
        isPACBTour || currentStep !== -1 ? (
          <SlideModal
            currentStep={currentStep < 0 ? 0 : currentStep}
            setCurrentStep={(value: number) => setCurrentStep(value)}
            closeModal={closeModal}
            isPACBTour={isPACBTour}
          />
        ) : (
          <WhatsNewModal
            currentStep={currentStep}
            setCurrentStep={(value: number) => setCurrentStep(value)}
            closeModal={closeModal}
          />
        )
      ) : (
        ''
      )}
    </>
  );
};

const mapStateToProps = ({ loginReducer }) => ({
  showGuidedTour: loginReducer?.loginState?.showGuidedTour,
});

export default connect(mapStateToProps, { updateUserDetailsAction })(Tour);
